import React from 'react';
import FormField from '../shared/FormField';
import SelectField from '../shared/SelectField';

const EnvironmentalConditions = ({ 
  formData, 
  updateFormData, 
  errors = {},
  loading = false 
}) => {
  const handleFieldChange = (updates) => {
    updateFormData(updates);
  };

  return (
    <div className="space-y-6">
      {/* Section Header */}
      <div className="border-b border-gray-200 pb-4">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-10 h-10 bg-cyan-100 rounded-full">
              <svg className="w-6 h-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
              </svg>
            </div>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Environmental Conditions</h2>
            <p className="text-sm text-gray-600 mt-1">
              Describe the environmental conditions at the time of the event.
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          label="Weather Conditions"
          name="weather_conditions"
          type="text"
          value={formData.weather_conditions}
          onChange={handleFieldChange}
          error={errors.weather_conditions}
          placeholder="e.g., Clear, Rainy, Cloudy, Windy, Thunderstorm"
          maxLength={100}
          helpText="General weather at the time of the event"
          disabled={loading}
        />

        <SelectField
          label="Lighting Conditions"
          name="lighting_conditions"
          value={formData.lighting_conditions}
          onChange={handleFieldChange}
          options={[
            { value: 'Natural', label: 'Natural Daylight' },
            { value: 'Artificial', label: 'Artificial Lighting' },
            { value: 'Poor', label: 'Poor Lighting' },
            { value: 'Adequate', label: 'Adequate Lighting' }
          ]}
          error={errors.lighting_conditions}
          placeholder="Select lighting condition"
          disabled={loading}
        />

        <SelectField
          label="Surface Conditions"
          name="surface_conditions"
          value={formData.surface_conditions}
          onChange={handleFieldChange}
          options={[
            { value: 'Dry', label: 'Dry' },
            { value: 'Wet', label: 'Wet' },
            { value: 'Oily', label: 'Oily' },
            { value: 'Contaminated', label: 'Contaminated' }
          ]}
          error={errors.surface_conditions}
          placeholder="Select surface condition"
          helpText="Condition of work surface/floor"
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default EnvironmentalConditions;
